import { createRouter, createWebHistory } from 'vue-router'
import loginGuard from './beforeEachGuard/loginGuard'
import routes from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach(loginGuard)

export default router
